var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',[_c('v-col',{attrs:{"lg":"6"}},[_c('maintainer-crop',{attrs:{"isAdmin":true,"height":100},on:{"rowSelected":function($event){return _vm.rowSelected($event)}}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('maintainer-article',{attrs:{"isAdmin":true,"DedID":_vm.dedID,"height":200}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }